import script from "./InputWeight.vue?vue&type=script&setup=true&lang=js"
export * from "./InputWeight.vue?vue&type=script&setup=true&lang=js"

import "./InputWeight.vue?vue&type=style&index=0&id=7b99768c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b99768c"]])

export default __exports__